export default {
  windowEl: window,
  documentEl: document,
  htmlEl: document.documentElement,
  bodyEl: document.body,
  testiSliderEl: document?.querySelector('.testimonials__slider'),
  testiPag: document?.querySelector('.testimonials-pagination'),
  clientsSliderEl: document?.querySelector('.clients__slider'),
}
